<template>
	<el-dialog :visible.sync="showbaseinfowin" title="基础信息" width="500px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="true">
		<table class="basetable">
			<tr>
				<td style="80px"><span>资料类型</span></td>
				<td>
					<el-select :disabled="isedit" size="mini" v-model="form.d_type" @change="dtypechange" placeholder="请选择资料类型">
						<el-option v-for="(item,index) in typelist" :label="item.d_type" :value="item.d_type" :key="index"></el-option>
					</el-select>
				</td>
			</tr>
			<tr v-for="(item,index) in typeformat" :key="index">
				<td style="width:80px">
					<span>{{ item.title }}</span>
				</td>
				<td>
					<el-input size="mini" v-model="item.value" v-if="item.controltype == 'text'" :disabled="item.isedit=='0'"></el-input>
					<el-input size="mini" v-model="item.value" v-if="item.controltype == 'textarea'" type="textarea" :rows="5"></el-input>
					<el-select size="mini" v-model="item.value" v-if="item.controltype == 'select'">
						<el-option v-for="(option,idx) in item.options" :label="option.name" :value="option.value" :key="idx"></el-option>
					</el-select>
					<br />
					<span class="tips" v-if="item.remark!=''">{{item.remark}}</span>
				</td>
			</tr>
		</table>
		<span slot="footer" class="dialog-footer">
			<div style="text-align: center;width:100%">
				<el-button size="mini" type="success" @click.native="SaveBaseInfo">保存</el-button>
				<el-button size="mini" type="info" plain @click.native="showbaseinfowin = false">取消</el-button>
			</div>
		</span>
	</el-dialog>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {
	},
	data() {
		return {
			form: {
				id:'',
				d_name: '',
				d_type: '',
				d_value: '',
				d_index: 0,
				remark: ''
			},
			typelist: [],
			typeformat:[],
			isremark: false,
			showbaseinfowin: false,
			isedit:false,
			isperssmion:false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/baseinfo/baseinfo.scss');
		});
	},
	methods: {
		init(param) {
			this.showbaseinfowin = true;
			if (param != undefined) {
				this.form = param.info;
			}else{
				this.form={
					id:'',
					d_name: '',
					d_type: '',
					d_value: '',
					d_index: 0,
					remark: ''
				}
				this.typeformat=[];
				this.isedit=false;
				this.isperssmion=false;
			}
			this.GetBaseType();
		},
		//获取资料类型
		GetBaseType(){
			//debugger
			var that=this;
			this.$apipost.get.GetBaseType().then(res => {
				if(res.list!=undefined)
					that.typelist=res.list;
					var list = that.typelist.filter(function(e) {
						return e.d_type==that.form.d_type;
					});
					if(list.length>0){
						that.isedit=true;
						that.typeformat=JSON.parse(list[0].typeformat);
						that.isperssmion=list[0].isperssmion;
						that.typeformat.forEach(info=>{
							for (var key in that.form) {
								if(info.colname==key)
									info.value=that.form[key];
							}
						});
					}
			});
		},
		dtypechange(changevalue) {
			var list = this.typelist.filter(function(e) {
				return e.d_type.toLowerCase().indexOf(changevalue.toLowerCase()) > -1;
			});
			if(list.length>0){
				this.typeformat=JSON.parse(list[0].typeformat);
				this.isperssmion=list[0].isperssmion;
				if(!this.isedit)
				{
					this.typeformat.forEach(e=>{
						if(e.isedit!=undefined)
							e.isedit='1';
					});
				}
			}
				
		},
		//保存基础资料
		SaveBaseInfo() {
			var paraminfo={
				id:this.form.id,
				d_type:this.form.d_type,
				typeformat:this.typeformat,
				isperssmion:this.isperssmion
			}
			var that=this;
			this.$apipost.post.SaveBaseInfo({paraminfo:paraminfo}).then(res => {
				if(res.state=='1'){
					this.$tool.message('保存成功', 1);
					this.showbaseinfowin=false;
					that.$parent.refreshgrid(true);
				}else{this.$tool.message(res.message, 0);}
			});
		}
	}
};
</script>

<style></style>
